import type { InitOptions } from 'i18next';

const i18nextDefaultInitOptions: InitOptions = {
  supportedLngs: ['en', 'ru', 'uk'],
};

export { i18nextDefaultInitOptions };
